import Cookies from 'js-cookie';
import uuid from 'uniqid';
import {
  GET_IN_ANONYMOUS_ID,
} from './constants';

type EventProps = {
  [key: string]: unknown;
};

export const Event = {
  push: (name: string, props?: EventProps) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];

      let anonymous_id = Cookies.get(GET_IN_ANONYMOUS_ID);

      if (!anonymous_id) {
        anonymous_id = uuid();
        Cookies.set(GET_IN_ANONYMOUS_ID, anonymous_id);
      }

      const params: EventProps = {
        event: name,
        anonymous_id,
        ...props,
      };

      if (props?.diner_id || props?.user_id) {
        delete params.anonymous_id;
      }

      window.dataLayer.push(params);
    }
  },
};
